import withSuspense from "../../../../hocs/withSuspense";
import {
  EditMailingAddressPageProps,
  EditMailingAddressPage,
} from "./EditMailingAddressPage";
import { ContactInfoSkeleton, SettingsError } from "../../components";

export const EditMailingAddressPageWithSuspense =
  withSuspense<EditMailingAddressPageProps>(EditMailingAddressPage, {
    FallbackComponent: SettingsError,
    loading: <ContactInfoSkeleton rows={5} testId="edit-mailing-address" />,
  });
